export default "__VITE_ASSET__CRQt9CHQ__"